enum Priority {
  Low = 'Low',
  Normal = 'Normal',
  High = 'High',
}

export default Priority;
